function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5597 8.16658L13.7063 7.02658H13.693C14.3068 6.39061 14.6431 5.53707 14.6281 4.65336C14.6131 3.76966 14.248 2.92803 13.613 2.31325C12.991 1.71338 12.1605 1.37817 11.2963 1.37817C10.4322 1.37817 9.60171 1.71338 8.97967 2.31325L7.83301 3.45325M3.44663 7.83325L2.30663 8.97325C1.69287 9.60923 1.35658 10.4628 1.37157 11.3465C1.38657 12.2302 1.75164 13.0718 2.38663 13.6866C3.00866 14.2865 3.83913 14.6217 4.70329 14.6217C5.56745 14.6217 6.39792 14.2865 7.01996 13.6866L8.15996 12.5466M5.33301 1.33325V3.33325M1.33301 5.33325H3.33301M10.667 12.6667V14.6667M12.667 10.6667H14.667",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgUnmap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmap);
export default __webpack_public_path__ + "static/media/unmap.66cf3707.svg";
export { ForwardRef as ReactComponent };